import { createFileRoute, redirect } from '@tanstack/react-router';

import { isMarket, type Market } from '@/lib/market/types';

/** §10.1：`index.tsx` → 導向上次的 market。 */
function lastMarket(): Market {
  try {
    const stored = localStorage.getItem('stock.market');
    if (isMarket(stored)) return stored;
  } catch {
    // 私密視窗／封鎖 site data：走預設，不是錯誤路徑。
  }
  return 'tw';
}

export const Route = createFileRoute('/')({
  beforeLoad: ({ search }) => {
    throw redirect({
      to: '/$market/dashboard',
      params: { market: lastMarket() },
      // as_of 必須跟著走。少了這一行，帶 ?as_of= 的分享連結打開根路徑就會掉回今天。
      search,
      replace: true,
    });
  },
});
